<template>
  <v-card class="mb-8" elevation="0">
    <v-card-text>
      <div class="subtitle-1 font-weight-bold mb-4">
        <v-icon left>mdi-format-list-bulleted-type</v-icon>
        {{ $t("select_limit_type") }}
      </div>
      <div>
        <!-- Narudžba -->
        <selectable-card
          value="order"
          :current-value="config.limit_definition.active"
          icon="mdi-food"
          icon-color="primary"
          :title="$t('order_limit')"
          :description="$t('order_limit_desc')"
          @select="config.limit_definition.active = $event"
        >
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 mb-2">{{ $t("limit_applies_to") }}</div>
              <v-checkbox
                v-model="config.limit_definition.settings.limit_by_quantity"
                :label="$t('number_of_orders')"
                :hint="$t('number_of_orders_hint')"
                persistent-hint
                dense
                class="mb-2"
              />
              <v-checkbox
                v-model="config.limit_definition.settings.limit_by_value"
                :label="$t('order_value')"
                :hint="$t('order_value_hint')"
                persistent-hint
                dense
              />
            </v-col>
          </v-row>
        </selectable-card>

        <!-- Vaucer -->
        <selectable-card
          value="voucher"
          :current-value="config.limit_definition.active"
          icon="mdi-ticket"
          icon-color="success"
          :title="$t('voucher_limit')"
          :description="$t('voucher_limit_desc')"
          @select="config.limit_definition.active = $event"
        >
          <v-radio-group
            v-model="config.limit_definition.settings.orders_per_voucher"
            mandatory
            class="mb-3"
          >
            <div class="subtitle-2 mb-2">{{ $t("voucher_applies_to") }}</div>
            <v-radio :value="0" class="mb-2">
              <template v-slot:label>
                <div>
                  <strong>{{ $t("specific_amount_of_money") }}</strong>
                  <div class="text-caption grey--text">
                    {{ $t("voucher_has_monetary_value") }}
                  </div>
                </div>
              </template>
            </v-radio>
            <v-radio :value="1">
              <template v-slot:label>
                <div>
                  <strong>{{ $t("number_of_orders_voucher") }}</strong>
                  <div class="text-caption grey--text">
                    {{ $t("voucher_enables_orders") }}
                  </div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-row v-if="config.limit_definition.settings.orders_per_voucher === 0">
            <v-col cols="12" sm="6">
              <text-field
                v-model="config.limit_definition.settings.value_per_voucher"
                :label="$t('voucher_value')"
                type="number"
                :suffix="config.limit_definition.settings.currency || restaurantCurrency"
                outlined
                dense
                :hint="$t('voucher_value_hint')"
                persistent-hint
              />
            </v-col>
          </v-row>
          <v-row v-if="config.limit_definition.settings.orders_per_voucher === 1">
            <v-col cols="12" sm="6">
              <text-field
                v-model="config.limit_definition.settings.value_per_voucher"
                :label="$t('orders_per_voucher')"
                type="number"
                outlined
                dense
                :hint="$t('orders_per_voucher_hint')"
                persistent-hint
              />
            </v-col>
          </v-row>
        </selectable-card>

        <!-- Kredit -->
        <selectable-card
          value="credit"
          :current-value="config.limit_definition.active"
          icon="mdi-wallet"
          icon-color="orange"
          :title="$t('credit_limit')"
          :description="$t('credit_limit_desc')"
          @select="config.limit_definition.active = $event"
        >
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="config.limit_definition.settings.allow_negative"
                :label="$t('allow_negative_balance')"
                :hint="$t('allow_negative_hint')"
                persistent-hint
                dense
              />
            </v-col>
          </v-row>
        </selectable-card>

        <!-- Novac -->
        <selectable-card
          value="money"
          :current-value="config.limit_definition.active"
          icon="mdi-cash"
          icon-color="green"
          :title="$t('money_limit')"
          :description="$t('money_limit_desc')"
          @select="config.limit_definition.active = $event"
        />

        <!-- Nema limita -->
        <selectable-card
          value="unlimited"
          :current-value="config.limit_definition.active"
          icon="mdi-infinity"
          icon-color="grey"
          :title="$t('no_limit')"
          :description="$t('no_limit_desc')"
          @select="config.limit_definition.active = $event"
          :last="true"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import restaurant from "../../../store/restaurant";
import SelectableCard from "../cards/SelectableCard.vue";

export default {
  name: "LimitTypeSelector",
  components: {
    SelectableCard,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
};
</script>
